/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import cx from 'classnames';
import $ from 'jquery';
import Chart from 'chart.js/auto';
import LitigatorDetailModal from '../Modal/LitigatorDetailModal';
import api from '../../api';
import './ComponentSummaryView.css';

class ComponentSummaryView extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.state = {
      isOpenMLD: false,
      litigatorData: {},
    };
    this.handleLitigatorDetailModal = this.handleLitigatorDetailModal.bind(this);
    this.handleMLDClose = this.handleMLDClose.bind(this);
  }

  componentDidMount() {
    if (this.canvas) {
      this.drawChart();
    }
    $(document).on(
      'mouseenter',
      '.component_summary.summary_item_table .name',
      function () {
        const $this = $(this);
        if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
          $this.attr('title', $this.text());
        } else {
          $(this).removeAttr('title');
        }
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.file.componentCount.total
      !== this.props.file.componentCount.total
    ) {
      this.drawChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  handleMLDClose() {
    this.setState({
      isOpenMLD: false,
    });
  }

  handleLitigatorDetailModal(e, string) {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api
      .getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  drawChart() {
    const { translate } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const total_label = translate('chart.title.total_lowercase');
    const risk_labe = translate('chart.title.risk');

    const config = {
      type: 'pie',
      data: {
        datasets: [
          {
            label: [total_label, risk_labe],
            data: [
              this.props.file.componentCount.has_risk,
              this.props.file.componentCount.total
                - this.props.file.componentCount.has_risk,
            ],
            backgroundColor: ['#ff7d00', '#ADA9B2'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        //responsive: true,
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.canvas.getContext('2d');
    this.chart = new Chart(ctx, config);
  }

  render() {
    const { translate } = this.props;
    const { litigatorData } = this.state;
    return (
      <table className="component_summary summary_item_table small">
        <colgroup>
          <col width="30%" />
          <col width="30%" />
          <col width="" />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.component')}</p>
                <p className="value">{this.abbreviateNumber(this.props.file.componentCount.total)}</p>
              </div>
              <div className="summary_chart pie">
                <span className="value">
                  {Math.ceil(
                    (this.props.file.componentCount.has_risk
                      / this.props.file.componentCount.total)
                      * 100
                  ) || 0}
                  %
                </span>
                <canvas
                  ref={(ref) => {
                    this.canvas = ref;
                  }}
                />
              </div>
              <div className="summary_issues">
                <div className="no_issue">
                  <p className="label">{translate('panel.menu.no_issues')}</p>
                  <p className="val">
                    {this.abbreviateNumber(this.props.file.componentCount.total
                      - this.props.file.componentCount.has_risk)}
                  </p>
                </div>
                <div className="with_issue">
                  <p className="label">{translate('panel.menu.with_issues')}</p>
                  <p className="val">
                    {this.abbreviateNumber(this.props.file.componentCount.has_risk)}
                  </p>
                </div>
              </div>
            </td>
            <td>
              <div className="list_wrap">
                <p className="list_title">{translate('panel.menu.most_found_components')}</p>
                <ul>
                  <li className="normal">
                    <table style={{ tableLayout: 'fixed' }}>
                      <colgroup>
                        <col width="" />
                        <col width="15%" />
                      </colgroup>
                      <tbody>
                        {this.props.file.mostFound
                          ? this.props.file.mostFound.map((item) => {
                            return (
                              <tr key={item.component_name.toString()}>
                                <td>
                                  <span className="name">
                                    {item.component_name}
                                  </span>
                                </td>
                                <td>{item.uploaded_file_count}</td>
                              </tr>
                            );
                          })
                          : null}
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
            </td>
            <td>
              <div className="list_wrap">
                <p className="list_title">{translate('panel.menu.most_vulnerable_components')}</p>
                <ul>
                  <li className="normal">
                    <table style={{ tableLayout: 'fixed' }}>
                      <colgroup>
                        <col width="50%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="" />
                      </colgroup>
                      <tbody>
                        {this.props.file.mostVuln
                          ? this.props.file.mostVuln.map((item) => {
                            return (
                              <tr key={item.component_name.toString()}>
                                <td>
                                  <span className="name">
                                    {item.component_name}
                                  </span>
                                </td>
                                <td>
                                  <div
                                    className={cx(
                                      'bullet',
                                      {
                                        red:
                                            item.security_count.top_risk
                                            === 'critical',
                                      },
                                      {
                                        orange:
                                            item.security_count.top_risk
                                            === 'high',
                                      },
                                      {
                                        cheese:
                                            item.security_count.top_risk
                                            === 'medium',
                                      },
                                      {
                                        yellow:
                                            item.security_count.top_risk
                                            === 'low',
                                      }
                                    )}
                                  >
                                    {item.security_count.total}
                                  </div>
                                </td>
                                <td>
                                  <div
                                    className={cx(
                                      'bullet round',
                                      {
                                        red:
                                            item.license_count.top_risk === 'protective' && item.license_count.total !== 0,
                                      },
                                      {
                                        orange:
                                            item.license_count.top_risk === 'permissive' && item.license_count.total !== 0,
                                      },
                                      {
                                        yellow:
                                            item.license_count.top_risk === 'others' && item.license_count.total !== 0,
                                      }
                                    )}
                                  >
                                    {item.license_count.total}
                                  </div>
                                </td>
                                <td
                                  className="has_link"
                                  style={{ fontSize: '10px', padding: '0px' }}
                                >
                                  <span
                                    onClick={(e) => {
                                      return this.handleLitigatorDetailModal(
                                        e,
                                        item.litigator_string
                                      );
                                    }}
                                    onKeyUp={(e) => {
                                      return this.handleLitigatorDetailModal(
                                        e,
                                        item.litigator_string
                                      );
                                    }}
                                  >
                                    {item.litigator_string}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                          : null}
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
              <LitigatorDetailModal
                isOpenMLD={this.state.isOpenMLD}
                closeModal={this.handleMLDClose}
                litigatorData={litigatorData}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
ComponentSummaryView.defaultProps = {
  file: {},
};

export default ComponentSummaryView;
